var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"torso two-column alternate dense"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wrap seismic-v2"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }